/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateZendeskJwtInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type CreateZendeskJwtMutationVariables = {|
  input: CreateZendeskJwtInput
|};
export type CreateZendeskJwtMutationResponse = {|
  +createZendeskJwt: ?{|
    +jwt: ?string
  |}
|};
export type CreateZendeskJwtMutation = {|
  variables: CreateZendeskJwtMutationVariables,
  response: CreateZendeskJwtMutationResponse,
|};
*/


/*
mutation CreateZendeskJwtMutation(
  $input: CreateZendeskJwtInput!
) {
  createZendeskJwt(input: $input) {
    jwt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateZendeskJwtInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateZendeskJwtPayload",
    "kind": "LinkedField",
    "name": "createZendeskJwt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jwt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateZendeskJwtMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateZendeskJwtMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateZendeskJwtMutation",
    "operationKind": "mutation",
    "text": "mutation CreateZendeskJwtMutation(\n  $input: CreateZendeskJwtInput!\n) {\n  createZendeskJwt(input: $input) {\n    jwt\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66263505b25e3cd5d5c47d13c7d63b92';

module.exports = node;
